





















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAllocationSearchParameters } from '@/interfaces/allocation';
import 'vue-select/dist/vue-select.css';
import ResultsPanel from './results-panel.vue';

@Component
export default class SearchPanel extends Vue {
    @Prop() from!: string[];
    @Prop() to!: string[];
    @Prop() carrier!: string[];
    @Prop() client!: string[];
    private submitted = false;
    private searchParameters: IAllocationSearchParameters = {
        // TODO: set default departure date value
        departureDate: new Date(),
        from: '',
        to: '',
        carrier: [],
        client: [],
    };

    search(): void {
        this.submitted = true;

        // validate search expression
        if (!this.CanSearch) {
            // TODO : display message / toast
            return;
        }

        const searchParameters = this.searchParameters;

        this.$emit('search', searchParameters);
    }

    get CanSearch(): boolean {
        // Check required
        return (
            this.searchParameters.from !== '' && this.searchParameters.to !== ''
        );
    }
}
